import { Creator, UserSlice } from 'store/types';

export const createUserSlice: Creator<UserSlice> = (set) => ({
  isUserInternetOnline: true,
  plutoApiStatusCode: undefined,
  setIsUserInternetOnline: (connectionStatus: boolean) =>
    set(() => ({ isUserInternetOnline: connectionStatus })),
  setPlutoApiStatusCode: (statusCode: string) =>
    set(() => ({ plutoApiStatusCode: statusCode })),
});
